import { useCallback, useEffect, useState } from "react";
import { Table } from "../Table/Table";
import { useNavigate } from "react-router-dom";
import "./Messages.css";
import { sortTableDataByDateTime } from "../_shared/utils";
import { useGetMessagesQuery } from "../../graphql/generated/graphql";
import { PolicyStatusPill } from "../_shared/StatusPill";
import { Container } from "react-bootstrap";
import { Flex, Heading } from "@aws-amplify/ui-react";
import { Spinner } from "../_shared/Loader";

export const Messages = () => {
  const [filteredMessageList, setFilteredMessageList] = useState<any>([]);
  const [loadingMessages, setLoadingMessages] = useState(true);

  const { data, loading, error } = useGetMessagesQuery();

  console.log("Messages query - loading: ", loading);
  console.log("Messages query - error: ", error);
  console.log("Messages query - data: ", data);
  
  const navigate = useNavigate();

  const filterMessages = useCallback(async (data) => {

    console.log("Filtering messages with data: ", data);

    const filteredMessages = data?.getMessages?.map((message) => {
      return {
        ...message,
        Active: <PolicyStatusPill active={message.Active} />,
        HasCTAButton: !message.HasCTAButton ? "No" : "Yes",
      };
    });
    const sortedMessages = sortTableDataByDateTime(filteredMessages);
    setFilteredMessageList(sortedMessages);
  }, []);

  const handleMessages = useCallback(async () => {
    setLoadingMessages(true);
    try {
      if (loading || error || !data) throw error;
      filterMessages(data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingMessages(false);
    }
  }, [loading, data, error, filterMessages]);

  const selectMessage = (row, isSelect, rowIndex, e) => {
    navigate(`/messages/${row.id}`);
  };

  useEffect(() => {
    handleMessages();
  }, [handleMessages]);

  return (
    <Container style={{ padding: 25 }} fluid>
      <Flex direction="column" gap="1.5rem">
        <Heading level={2} className="screen-title">
          Messages
        </Heading>
        <div style={{ display: "flex", flex: 1 }}>
          {loadingMessages && <Spinner loading={loadingMessages} />}
          <Table
            tableRows={filteredMessageList}
            excludeKeys={[
              "__typename",
              "Summary",
              "Description",
              "TMCUsers",
              "TIUsers",
              "Renewals",
              "Marketing",
              "GuestUsers",
              "LoggedInUsers",
              "AllUsers",
              "StartDate",
              "EndDate",
              "MatchAll",
              "ButtonLabel",
              "CallToActionText",
              "CallToActionType",
              "CallToActionBtnColor",
              "IsWebLink",
              "WebLinkURL",
              "id",
            ]}
            pagination={10}
            handleSelect={selectMessage}
          />
        </div>
      </Flex>
    </Container>
  );
};
